import { Avatar, Card, CardHeader, IconButton, Skeleton } from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import React from "react";
import { useDocumentDataOnce } from "react-firebase-hooks/firestore";

import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { COLLECTIONS } from "firebaseCollections";

export default function UserInGroup({ group, uid }) {

  const [userData, loading, error] = useDocumentDataOnce(
    doc(db, "userPublicProfiles", uid)
  );

  if (error) {
    console.log(error);
  }

  const renderField = (field) => {
    if(loading) {
      return (
        <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
      );
    }
    return userData[field];
  }

  const handleRemoveUser = async () => {
    const newMembers = group.members.filter((member) => member !== uid);
    console.log(newMembers);
    await updateDoc(doc(db, COLLECTIONS.userGroups, group.id), {
      members: newMembers,
    });
  }

  return (
    <Card>
      <CardHeader
        avatar={
          loading ? (
            <Skeleton variant="circular" width={40} height={40} />
          ) : (
            <Avatar alt={userData.username} src={userData.avatarUrl} />
          )
        }
        title={renderField("username")}
        //subheader={renderField("email")}
        action={
          uid !== group.owner && (
            <IconButton
            color="secondary"
            onClick={handleRemoveUser}
          >
            <PersonRemoveIcon />
          </IconButton>
          )
        }
      />
    </Card>
  );
}
